import React from 'react';
import { TableContainer, Card, Grid } from '@mui/material';
import {
  UserAccountSection,
  UserAccountsTableData,
} from '../../../data/report/helpers/userAccountsUtils';
import SectionedTableView from './SectionedTableView';

interface UserAccountsTableProps {
  data: UserAccountsTableData;
  columns: string[];
  sections: UserAccountSection[];
}

const UserAccountsTable: React.FC<UserAccountsTableProps> = ({ data, columns, sections }) => {
  return (
    <Grid container mb={3}>
      <Card variant='ghost' color='transparent'>
        <TableContainer>
          <SectionedTableView sections={sections} columns={columns} data={data} />
        </TableContainer>
      </Card>
    </Grid>
  );
};

export default UserAccountsTable;
